/* arēta storefront JS: progressive enhancement only. Everything works without it
   (forms post to /cart). Keep this file small: no libraries. */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const drawer = document.getElementById('CartDrawer');
  let lastFocus = null;

  /* ---------- Analytics: custom events for Shopify Customer Events ---------- */
  const track = (name, data) => {
    try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  };
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-track]');
    if (!el) return;
    track('areta_cta_click', { id: el.dataset.track, text: (el.textContent || '').trim().slice(0, 80), path: location.pathname });
  });

  /* ---------- Cart drawer ---------- */
  const sectionsParam = 'cart-drawer';
  const renderSections = (sections) => {
    if (!sections || !sections['cart-drawer']) return;
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const next = doc.querySelector('[data-cart-drawer-inner]');
    const current = drawer && drawer.querySelector('[data-cart-drawer-inner]');
    if (next && current) current.replaceWith(next);
    const count = next ? next.dataset.count : null;
    document.querySelectorAll('[data-cart-count]').forEach((n) => { n.textContent = count && count !== '0' ? count : ''; });
  };

  const openDrawer = () => {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const close = drawer.querySelector('.drawer__close');
    if (close) close.focus();
    track('areta_cart_drawer_open', { path: location.pathname });
    return true;
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { if (openDrawer()) e.preventDefault(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      const f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Add to cart (AJAX, falls back to normal POST) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-buy-form]');
    if (!form || !drawer) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    if (err) { err.hidden = true; err.textContent = ''; }
    try {
      const direct = !!form.querySelector('[data-direct-checkout]');
      if (direct) {
        /* single-product funnel: exactly one item, then straight to checkout (add.js still emits AddToCart) */
        await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
        const fd = new FormData(form); fd.delete('return_to');
        const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        const d = await r.json();
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'Fehler');
        track('areta_buy_now', { path: location.pathname });
        location.href = `${root}checkout`;
        return;
      }
      const body = new FormData(form);
      body.append('sections', sectionsParam);
      body.append('sections_url', location.pathname);
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Fehler');
      renderSections(data.sections);
      openDrawer();
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else { form.submit(); }
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  });

  /* Quantity changes in drawer */
  const changeLine = async (key, quantity) => {
    const inner = drawer && drawer.querySelector('[data-cart-drawer-inner]');
    if (inner) inner.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: sectionsParam, sections_url: location.pathname })
      });
      const data = await res.json();
      renderSections(data.sections);
    } catch (ex) { location.href = `${root}cart`; }
  };
  const lineTarget = (el) => el.closest('[data-line]');
  const afterChange = (el) => (el.closest('#CartDrawer') ? null : location.reload());
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    e.preventDefault();
    const line = lineTarget(b);
    const input = line.querySelector('input');
    const next = Math.max(0, parseInt(input.value, 10) + parseInt(b.dataset.qtyChange, 10));
    await changeLine(line.dataset.key, next);
    afterChange(b);
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line] input');
    if (!input) return;
    await changeLine(lineTarget(input).dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    afterChange(input);
  });

  /* ---------- Sticky mobile buy bar ---------- */
  const sticky = document.querySelector('[data-sticky-buy]');
  const anchor = document.querySelector('[data-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    const footer = document.querySelector('.site-footer');
    let anchorVisible = true, footerVisible = false;
    const update = () => { const on = !anchorVisible && !footerVisible; sticky.classList.toggle('is-visible', on); document.body.classList.toggle('sticky-buy-on', on); };
    new IntersectionObserver(([e]) => { anchorVisible = e.isIntersecting || e.boundingClientRect.top > 0; update(); }).observe(anchor);
    if (footer) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; update(); }).observe(footer);
  }

  /* ---------- Generic carousel (Stimmen): arrows scroll one card ---------- */
  document.querySelectorAll('[data-carousel]').forEach((c) => {
    const rail = c.querySelector('[data-carousel-track]');
    const prev = c.querySelector('[data-carousel-prev]'), next = c.querySelector('[data-carousel-next]');
    if (!rail || !prev || !next) return;
    const step = () => (rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth);
    const bar = c.querySelector('[data-carousel-progress]');
    const sync = () => {
      prev.disabled = rail.scrollLeft < 4; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      if (bar) bar.style.setProperty('--p', Math.min(100, ((rail.scrollLeft + rail.clientWidth) / rail.scrollWidth) * 100) + '%');
    };
    /* jump to the next/previous card's snap position (robust with scroll-snap) */
    const go = (dir) => {
      const base = rail.firstElementChild ? rail.firstElementChild.offsetLeft : 0;
      const stops = [...rail.children].map((el) => el.offsetLeft - base);
      const x = rail.scrollLeft, max = rail.scrollWidth - rail.clientWidth;
      const target = dir > 0 ? (stops.find((p) => p > x + 4) ?? max) : ([...stops].reverse().find((p) => p < x - 4) ?? 0);
      rail.scrollTo({ left: Math.min(target, max), behavior: 'smooth' });
    };
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => { go(1); track('areta_carousel_next', { id: c.className.split(' ')[0] }); });
    rail.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    sync();
  });

  /* ---------- Expertinnen switcher (tabs) ---------- */
  document.querySelectorAll('[data-expert-switch]').forEach((w) => {
    const tabs = [...w.querySelectorAll('[role="tab"]')];
    const show = (tab, focus) => {
      tabs.forEach((t) => { const on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      if (focus) tab.focus();
      track('areta_expert_switch', { expert: tab.textContent.trim().slice(0, 60) });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(t));
      t.addEventListener('keydown', (e) => { const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (d) { e.preventDefault(); show(tabs[(i + d + tabs.length) % tabs.length], true); } });
    });
  });

  /* ---------- Offer tiers: switch variant in every buy form of the section, update price, legal line, sticky bar ---------- */
  document.querySelectorAll('[data-offer]').forEach((offer) => {
    const sec = offer.closest('.shopify-section') || document;
    const btnLabel = (b) => b.dataset.label || (b.dataset.label = b.textContent.trim());
    const apply = (input, user) => {
      offer.querySelectorAll('.offer__tier').forEach((t) => t.classList.toggle('is-selected', t.contains(input)));
      sec.querySelectorAll('form[data-buy-form] input[name="id"]').forEach((i) => { i.value = input.value; });
      sec.querySelectorAll('form[data-buy-form] [type="submit"]').forEach((b) => { if (!b.closest('.sticky-buy')) b.innerHTML = `${btnLabel(b)} · <span class="num">${input.dataset.price}&#8239;€</span>`; });
      const out = sec.querySelector('[data-unit-out]'); if (out) out.textContent = input.dataset.unit;
      const free = input.dataset.free === '1';
      const paid = sec.querySelector('[data-ship-paid]'), fr = sec.querySelector('[data-ship-free]');
      if (paid) paid.hidden = free; if (fr) fr.hidden = !free;
      const sp = sec.querySelector('[data-sticky-price]'); if (sp) sp.innerHTML = `${input.dataset.price}&#8239;€`;
      const qty = parseInt(input.dataset.qty || '1', 10); let unlocked = 0;
      sec.querySelectorAll('[data-unlock-qty]').forEach((it) => { const lock = parseInt(it.dataset.unlockQty, 10) > qty; it.classList.toggle('is-locked', lock); if (!lock) unlocked++; });
      const lbl = sec.querySelector('[data-unlock-label]'); if (lbl) lbl.textContent = unlocked ? lbl.dataset.on : lbl.dataset.off;
      if (user) track('areta_offer_select', { variant: input.value, price: input.dataset.price });
    };
    offer.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"]')) apply(e.target, true); });
    const start = offer.querySelector('input:checked') || offer.querySelector('input'); if (start) apply(start, false);
  });

  /* ---------- Estimated delivery date (business days, same-day dispatch before cutoff) ---------- */
  document.querySelectorAll('[data-delivery]').forEach((el) => {
    const days = parseInt(el.dataset.days || '3', 10), cutoff = parseInt(el.dataset.cutoff || '14', 10);
    const d = new Date(); let added = 0;
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
    el.querySelector('[data-delivery-date]').textContent = d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    el.hidden = false;
  });

  /* ---------- FAQ open tracking (learning: which objections matter) ---------- */
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (d.matches && d.matches('details[data-faq]') && d.open) track('areta_faq_open', { question: d.querySelector('summary').textContent.trim().slice(0, 120) });
  }, true);

  /* ---------- Muscle chart: age slider + training toggle ---------- */
  document.querySelectorAll('[data-muscle-chart]').forEach((sec) => {
    const pts = { typ: JSON.parse(sec.dataset.typ), trn: JSON.parse(sec.dataset.trn) };
    const low = parseFloat(sec.dataset.low), high = parseFloat(sec.dataset.high);
    const range = sec.querySelector('[data-age]'), out = sec.querySelector('[data-age-out]');
    const readout = sec.querySelector('[data-readout]');
    const dot = sec.querySelector('[data-marker-dot]'), line = sec.querySelector('[data-marker-line]');
    const tpl = (n) => { const t = sec.querySelector(`[data-text-${n}]`); return t ? t.innerHTML.trim() : ''; };
    const texts = { typ: tpl('typ'), trn: tpl('trn'), band: tpl('band') };
    let mode = 'typ';
    const yAt = (arr, x) => {
      for (let i = 0; i < arr.length - 1; i++) {
        const [x0, y0] = arr[i], [x1, y1] = arr[i + 1];
        if (x >= x0 && x <= x1) return y0 + (y1 - y0) * ((x - x0) / (x1 - x0));
      }
      return arr[arr.length - 1][1];
    };
    const fmt = (n) => String(Math.round(n));
    const update = () => {
      const age = parseInt(range.value, 10);
      out.textContent = age;
      range.style.setProperty('--fill', ((age - range.min) / (range.max - range.min) * 100) + '%');
      const x = 56 + (age - 30) * 10.4, y = yAt(pts[mode], x);
      dot.setAttribute('cx', x); dot.setAttribute('cy', y);
      line.setAttribute('x1', x); line.setAttribute('x2', x);
      const decades = (age - 30) / 10;
      let msg;
      if (mode === 'trn') msg = texts.trn;
      else if (age <= 32) msg = 'Mit 30 liegt der Höhepunkt. Danach geht es langsam bergab.';
      else {
        msg = texts.typ.replace('[age]', `<span class="num">${age}</span>`).replace('[low]', `<span class="num">${fmt(decades * low)}</span>`).replace('[high]', `<span class="num">${fmt(decades * high)}</span>`).replace('[avg]', `<span class="num">${fmt(decades * (low + high) / 2)}</span>`);
        if (age >= 45 && age <= 55) msg += ' ' + texts.band;
      }
      readout.innerHTML = msg;
    };
    let tracked = false;
    range.addEventListener('input', () => { update(); if (!tracked) { tracked = true; track('areta_chart_interact', { type: 'age' }); } });
    sec.querySelectorAll('[data-mode]').forEach((b) => b.addEventListener('click', () => {
      mode = b.dataset.mode;
      sec.classList.toggle('is-trn', mode === 'trn');
      sec.querySelectorAll('[data-mode]').forEach((o) => o.setAttribute('aria-pressed', String(o === b)));
      const lt = sec.querySelector('[data-legend-trn]'); if (lt) lt.hidden = mode !== 'trn';
      const ct = sec.querySelector('[data-cta-trn]'); if (ct) ct.hidden = mode !== 'trn';
      update(); track('areta_chart_interact', { type: 'toggle', mode });
    }));
    update();
  });

  /* ---------- Modals (native <dialog>) ---------- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-modal-open]');
    if (o) { const d = document.getElementById(o.dataset.modalOpen); if (d && d.showModal) { e.preventDefault(); d.showModal(); } return; }
    if (e.target.closest('[data-modal-close]')) { const d = e.target.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close(); /* backdrop click */
  });

  /* ---------- Floating header: solid once the page scrolls ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let ticking = false, lastY = window.scrollY;
    const probe = () => {
      ticking = false;
      const sy = window.scrollY;
      header.classList.toggle('is-scrolled', sy > 24);
      /* logo floats without a background: hide it while reading (scrolling down), show it on the way back up */
      if (Math.abs(sy - lastY) > 6) { header.classList.toggle('is-reading', sy > lastY && sy > window.innerHeight * .6); lastY = sy; }
      /* what's underneath the header? switch to light elements on dark sections */
      const y = header.getBoundingClientRect().bottom - 20;
      header.style.visibility = 'hidden';
      const under = document.elementFromPoint(window.innerWidth / 2, Math.max(0, y));
      header.style.visibility = '';
      const dark = under && under.closest('.scheme-pflaume, .scheme-umbra, .drawer');
      header.classList.toggle('on-dark', !!dark);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(probe); } };
    probe(); window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
  }

  /* ---------- Gallery slider (scroll-snap + arrows + dots) ---------- */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('[data-gallery-track]');
    const slides = [...track.children];
    const dots = g.querySelectorAll('[data-gallery-dots] button');
    const prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    const index = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * track.clientWidth });
    const sync = () => {
      const i = index();
      dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    };
    if (prev) prev.addEventListener('click', () => go(index() - 1));
    if (next) next.addEventListener('click', () => go(index() + 1));
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    sync();
  });

  /* ---------- Comparison matrix: reveal + combine toggle ---------- */
  document.querySelectorAll('.matrix').forEach((m) => {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { m.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.25 });
      io.observe(m);
    } else m.classList.add('is-in');
    const t = m.querySelector('[data-matrix-toggle]');
    if (!t) return;
    t.addEventListener('click', () => {
      const on = t.getAttribute('aria-pressed') !== 'true';
      t.setAttribute('aria-pressed', String(on));
      m.classList.toggle('is-combined', on);
      m.querySelectorAll('.matrix__single').forEach((c) => { c.hidden = on; });
      m.querySelectorAll('.matrix__combo').forEach((c) => { c.hidden = !on; });
      track('areta_matrix_combine', { on });
    });
  });
})();
